export const openPluginButton = 'Record Vox voice message';
export const closePluginButton = 'Close Vox recorder';
export const hostedRecord = 'Record Vox voice message';
export const pluginRecord = 'Start recording';
export const stopRecButton = 'Stop recording';
export const playRecButton = 'Play back vox';
export const pauseRecButton = 'Pause playback';
export const reRecordButton = 'Delete and record new vox';
export const forwardButton = 'Confirm details before sending';
export const sendButton = 'Send vox';
export const micAccess = 'Cannot access microphone';
